import { render, staticRenderFns } from "./OnChainQuery.vue?vue&type=template&id=05990e79&scoped=true"
import script from "./OnChainQuery.vue?vue&type=script&lang=js"
export * from "./OnChainQuery.vue?vue&type=script&lang=js"
import style0 from "./OnChainQuery.scss?vue&type=style&index=0&id=05990e79&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05990e79",
  null
  
)

export default component.exports